export default __webpack_public_path__ + "static/media/logo1.6baacbc1.png";